export default __webpack_public_path__ + "static/Sprout-Social-a66193af3d27d2e6d168b935ed893317.png";